export enum MessageDialogType {
  Error,
  Info,
  ActionMessageInfo,
}
